import React, {Component} from 'react'
import {Table, Row, Col, Popconfirm, message, Button, Upload, Icon, Modal, Popover, Affix} from 'antd';
import QRCode from 'qrcode.react';
import SockJS  from 'sockjs-client';
import Stomp from 'stompjs';
import {reqFileList, reqSaveFile, baseUrl,fileThumb} from '../../api'
import './order-file.less';
import ajax from "../../api/ajax";
import qrcodeIcon from "../../components/icon/qrcode"
import {isImageUrl} from "antd/lib/upload/utils"
import authorizeBase from "../../components/authorize/authorizeBase";
import authorize from "../authorize/authorize";
const AuthButton = authorizeBase(Button)
const AuthPopover = authorizeBase(Popover)
let orderId;
export default class OrderFileComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileList: [],
            mobileurl:'',
            visible:false,
            orderId:"",
            readonly:false,
            inout:false,
            previewWidth:500,
            removeable:true,
            downloadable:true,
        }
    }
    handleWindowClose= (e) => {
        navigator.sendBeacon(baseUrl + '/cors/notice/logout')
    }
    componentDidMount() {
        let objectType = this.props.objectType?this.props.objectType:""
        authorize("order_edit:file_delete").then(()=>{
            this.setState({
                removeable:true
            })
        }).catch(()=>{
            this.setState({
                removeable:false
            })
        })
        authorize("order_edit:file_download").then(()=>{
            this.setState({
                downloadable:true
            })
        }).catch(()=>{
            this.setState({
                downloadable:false
            })
        })
        let {orderId} = this.props
        if(!orderId){
            if(this.props.location && this.props.location.state){
                orderId = this.props.location.state.orderId
            }
        }
        if(orderId) {
            this.setState({
                orderId
            })
            if(this.props.readonly){
                this.setState({
                    readonly:true
                })
            }else {
                this.getMobileUrl(orderId);
                this.initSockJs(orderId);
                window.addEventListener('beforeunload', this.handleWindowClose);
            }
            this.getFileList({orderId: orderId,objectType:objectType})
        }

    }
    componentWillUnmount(nextLocation) {
        if(!this.state.readonly) {
            this.handleWindowClose();
            window.removeEventListener('beforeunload', this.handleWindowClose);
        }
    }
    componentDidUpdate(preProps, preState, snapShot) {
        const func = this.props.getChildrenMsg;
        if (func != null && func instanceof Function && preState.fileList.length !== this.state.fileList.length) {
            func(this.props.objectType, this.state.fileList.length);
        }
    }
    getMobileUrl=async(orderId)=>{
        let result = await ajax(baseUrl+'/cors/sesstionid')
        if(result.code===200) {
            let redurl = window.location.origin+"/crm/mobileup/"+orderId
            if(this.props.objectType){
                redurl = redurl+"?objectType="+this.props.objectType
            }
            let url = baseUrl+"/cors/login/"+result.data+"?url="+encodeURIComponent(redurl);
            this.setState({
                mobileurl:url
            });
        }
    }

    initSockJs =(orderId)=>{
        const socket  = new SockJS(baseUrl+"/ws")
        const stompClient = Stomp.over(socket);
        var self = this;
        let objectType = this.props.objectType?this.props.objectType:""
        stompClient.connect({},  (frame)=> {
            stompClient.subscribe('/user/'+objectType+orderId+'/topic/file/upload', frame => {
                var result = JSON.parse(frame.body)
                if(result.code == 200) {
                    const item = result.data;
                    if(item.objectId == orderId) {
                        let showFiles = self.state.fileList;
                        item.uid = showFiles.length;
                        item.name = item.fileName;
                        item.thumbUrl = this.getThumbUrl(item.fileName)
                        item.url = baseUrl + '/' + item.filePath;
                        showFiles.push(item);
                        self.setState({
                            fileList: showFiles
                        })
                    }
                }
            });
            stompClient.subscribe('/user/'+objectType+orderId+'/topic/file/del', frame => {
                var result = JSON.parse(frame.body)
                if(result.code == 200) {
                    const file = result.data;
                    if(file.objectId == orderId) {
                        let showFiles = self.state.fileList;
                        const removedFileList = showFiles.filter(item => item["id"] !== file["id"]);
                        if (removedFileList.length === showFiles.length) {
                            return null;
                        }
                        if (removedFileList) {
                            self.handleChange({
                                file,
                                fileList: removedFileList,
                            });
                        }
                    }
                }
            });

        });
    }
    getThumbUrl=(fileName)=>{
        let thumbUrl = ""
        if(fileName.toLowerCase().endsWith(".docx") ||fileName.toLowerCase().endsWith(".doc") ){
            thumbUrl= fileThumb.word
        }else if(fileName.toLowerCase().endsWith(".xlsx") ||fileName.toLowerCase().endsWith(".xls") ){
            thumbUrl= fileThumb.excel
        }else if(fileName.toLowerCase().endsWith(".pdf") ){
            thumbUrl= fileThumb.pdf
        }
        return thumbUrl
    }
    getFileList = async (po) => {
        po.pageNum = 1;
        po.pageSize = 100;
        let result = await reqFileList(po)
        if (result.code === 200) {
            const fileList = result.data.rows;
            let showFiles = [];
            fileList.forEach((item, index) => {
                item.uid = index;
                item.name = item.fileName;
                item.thumbUrl = this.getThumbUrl(item.fileName)
                item.url = baseUrl + '/' + item.filePath;
                showFiles.push(item);
            });
            this.setState({
                fileList: showFiles
            })
        } else {
            message.error(result.message)
        }

    }
    handleRemove= info =>{
        if(!this.state.removeable){
            message.error("您没有权限删除！")
            return false
        }
        orderId = this.props.location.state.orderId;
        let result = ajax(baseUrl+'/api/v1/p/file/fileDel',{"fileId":info.id,"orderId":orderId},'DELETE');
        result.then(function(value) {
            if(value.code===200) {
                return true;
            }else{
                message.error(value.message)
            }
        }, function(error) {
            message.error(error)
        });

    };
    handleChange = info => {
        let fileList = [...info.fileList];

        // 1. Limit the number of uploaded files
        // Only to show two recent uploaded files, and old ones will be replaced by the new
        // fileList = fileList.slice(-2);

        // 2. Read from response and show file link
        fileList = fileList.map(file => {
            if (file.response) {
                // Component will show file.url as link
                if (file.response.code === 200) {
                    file.thumbUrl = this.getThumbUrl(file.response.data.fileName)
                    file.url = baseUrl + '/' + file.response.data.filePath;
                    file.id = file.response.data.id;
                } else {
                    file.status = 'error';
                    file.response = file.response.message;
                    // message.error(file.response.message);
                }
            }
            return file;
        });

        this.setState({fileList});
    };

    handleSave = () => {
        let values = {};
        values.orderId = orderId;
        const {fileList} = this.state;
        if (fileList && fileList.length > 0) {
            let fileids = [];
            fileList.forEach((item) => {
                if (item.id) {
                    fileids.push(item.id);
                }
            });
            values.fileIds = fileids;
        }
        this.saveFileData(values)
    }

    saveFileData = async (data) => {
        let result = await reqSaveFile(data)
        if (result.code === 200) {
            message.success(result.message);
        } else {
            message.error(result.message)
        }
    }

    hideModal = () =>{
        this.setState({
            visible:false
        })
    }
    uploadChange = () => {
        this.setState({
            visible:true
        })
    }
    getBase64  = (file) =>{
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    handlePreview = async file => {
        if(!this.state.downloadable){
            message.error("您没有权限查看和下载！")
            return false
        }
        let fileList = this.state.fileList
        let index = fileList.findIndex((value, index, obj) => {
            if(value.id && file.id){
                return value.id == file.id
            }else if(value.url && file.url){
                return value.url == file.url
            }
            return false
        })
        let pre = index-1;
        if(pre<0){
            pre = fileList.length-1;
        }
        let next = index+1;
        if(next>fileList.length-1){
            next = 0
        }
        if(isImageUrl({url:file.url})) {
            if (fileList.length > 1) {
                let count=0
                while (!isImageUrl({url: fileList[pre].url}) && count<fileList.length) {
                    count++
                    pre = pre - 1;
                    if (pre < 0) {
                        pre = fileList.length - 1;
                    }
                }
                count=0
                while (!isImageUrl({url: fileList[next].url})&& count<fileList.length) {
                    count++
                    next = next + 1;
                    if (next > fileList.length - 1) {
                        next = 0
                    }
                }
            } else {
                pre = 0
                next = 0
            }
            this.setState({
                previewPreFile: fileList[pre],
                previewNextFile: fileList[next]
            })
            if (!file.url && !file.preview) {
                file.preview = await this.getBase64(file.originFileObj);
            }
        }
        if(!isImageUrl({url:file.url})){
            window.open(file.url);
        }else {
            this.setState({
                previewImage: file.url || file.preview,
                previewVisible: true,
                inout: true,
            }, () => {
                //console.log( this.state.img.naturalWidth, this.state.img.naturalHeight)
            });
        }
    };
    handleCancel = () => this.setState({ previewVisible: false });
    handleBeforeUpload = (f, fList) => {
        return new Promise((resolve, reject) => {
            if (f.size > 10000000) {
                message.info("只能上传10M内文件");
                return reject(false);
            }
            return resolve(true);
        });
    };
    render() {
        const orderId = this.state.orderId;
        let objectType = this.props.objectType?this.props.objectType:""
        let props = {
            name: 'file',
            action: baseUrl + '/api/v1/p/file/upLoad?objectType='+objectType+'&orderId='+orderId,
            onChange: this.handleChange,
            onRemove:this.handleRemove,
            multiple: true,
            listType: 'picture',
            withCredentials: true,
            disabled:!this.state.removeable,
            onPreview:this.handlePreview,
            beforeUpload:this.handleBeforeUpload,
            showUploadList:{ showDownloadIcon:false }
        };
        if(this.state.readonly){
            props = {
                name: 'file',
                listType: 'picture',
                onPreview:this.handlePreview,
                disabled:true,
            };
        }
        const content = (
            <div>
                <QRCode value={this.state.mobileurl}/>
            </div>
        );
        const ct =(control)=>{
            if(control){
                let maxHeight = window.innerHeight;
                let maxWidth = window.innerWidth;
                if(maxHeight>maxWidth){
                    maxHeight = maxHeight*0.9
                }else {
                    maxWidth = maxWidth*0.9
                }

                const ratio = Math.min(maxWidth / control.naturalWidth, maxHeight / control.naturalHeight);
                const w=control.naturalWidth*ratio
                if(this.state.previewWidth!=w){
                    this.setState({
                        previewWidth:control.naturalWidth*ratio
                    })
                }
            }
        }


        return (
            <div className='order-space'>
                {!this.state.readonly?(
                    <div className='content-head-title orderFileQcode'>
                        <span>添加附件(gif, png, jpg, docx, doc, xlsx, xls, pdf,rar,zip)</span>
                        { !!this.props.noQrcode?null:<AuthPopover authority="order_edit:file_phoneupload" content={content} placement="right">
                            <Button  type="link" style={{marginLeft:20}} className='qrcodeStyle'>
                                <Icon component={qrcodeIcon} style={{width:30,height:30}}/>
                            </Button>
                        </AuthPopover>}
                    </div>
                ):("")}
                <Upload {...props} fileList={this.state.fileList}>
                {!this.state.readonly?(

                        <AuthButton authority="order_edit:file_pcupload" >
                            <Icon type="upload"/> 上传
                        </AuthButton>

                ):("")}
                </Upload>
                <Modal className="preview-image" centered visible={this.state.previewVisible} width={this.state.previewWidth} footer={null} onCancel={this.handleCancel} closable={false}>
                    <div className="ctrl">
                        <Icon type="zoom-in" className="icon" onClick={() => {
                            window.open(this.state.previewImage)
                        }}/>
                        <Icon type="close" className="icon" onClick={this.handleCancel}/>
                    </div>
                    <div className="ctrl-left">
                    <Icon type="left" className="icon left" onClick={() => {
                        this.setState({
                            inout:false
                        })
                        setTimeout(()=>{this.handlePreview(this.state.previewPreFile)},150)
                    }}/>
                    </div>
                    <div className="ctrl-right">
                    <Icon type="right" className="icon right"  onClick={() => {
                        this.setState({
                            inout:false
                        })
                        setTimeout(()=>{this.handlePreview(this.state.previewNextFile)},150)
                    }}/>
                    </div>
                    <img alt="" ref={ct} className={this.state.inout?'fadeIn':'fadeOut'}  style={{ width: '100%' }} src={this.state.previewImage} />
                </Modal>
                {!this.state.readonly?(
                    <Modal
                        title="请扫描二维码上传"
                        visible={this.state.visible}
                        onCancel={this.hideModal}
                        footer={[<Button onClick={this.hideModal} type='default'>关闭</Button>]}
                        className='phoneModel'
                    >
                        <QRCode value={this.state.mobileurl}/>
                    </Modal>
                ):("")}
            </div>
        )
    }
}